import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...entrees: ClassValue[]): string {
  return twMerge(clsx(entrees));
}

const formateurMonnaie = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2,
});

const formateurEntier = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 });

const formateurDate = new Intl.DateTimeFormat('fr-FR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

/**
 * Horodatage a la SECONDE.
 *
 * L'app utilisateur se contente de la minute. Un journal d'audit, non : deux actes
 * consecutifs sur la meme entreprise doivent pouvoir etre ordonnes a la lecture, sans
 * avoir a comparer les rangs de la chaine.
 */
const formateurHorodatage = new Intl.DateTimeFormat('fr-FR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
});

function analyser(valeur: string | null | undefined): Date | null {
  if (!valeur) return null;
  const date = new Date(valeur);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function montant(valeur: number | null | undefined): string {
  return valeur === null || valeur === undefined ? '—' : formateurMonnaie.format(valeur);
}

export function entier(valeur: number | null | undefined): string {
  return valeur === null || valeur === undefined ? '—' : formateurEntier.format(valeur);
}

export function date(valeur: string | null | undefined): string {
  const analysee = analyser(valeur);
  return analysee ? formateurDate.format(analysee) : '—';
}

export function horodatage(valeur: string | null | undefined): string {
  const analysee = analyser(valeur);
  return analysee ? formateurHorodatage.format(analysee) : '—';
}

/** Periode `yyyy-MM` du mois courant, telle que l'API l'attend. */
export function periodeCourante(): string {
  const maintenant = new Date();
  const mois = `${maintenant.getUTCMonth() + 1}`.padStart(2, '0');
  return `${maintenant.getUTCFullYear()}-${mois}`;
}

/** Raccourci d'identifiant, pour les colonnes ou l'UUID complet noierait la ligne. */
export function abrege(identifiant: string | null | undefined): string {
  return identifiant ? identifiant.slice(0, 8) : '—';
}
